import log from '@/logger'

const interceptorRequestSetup = config => {
  const { method, url } = config
  log.info('DATA Request', method, url)
  return config
}

export { interceptorRequestSetup }
